import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTheme } from 'styled-components';
import { useMemo } from 'react';
import { SwapStatusEnumKeys } from '@libs/types';
import { SwapFailedIcon, SwapProgressBarFirstIcon, SwapProgressBarFourthIcon, SwapProgressBarSecondIcon, SwapProgressBarThirdIcon, SwapSuccessIcon, } from '../../assets';
import { SwapStepTitle, Loader, CircleImg, StepWrapper, SwapProgressBarContainer, ProgressLine, } from './styles';
const SwapProgressBar = ({ swapStatus, firstStepTitle, secondStepTitle, thirdStepTitle, fourthStepTitle, className, }) => {
    const { colors } = useTheme();
    const DEPOSIT_STEPS = useMemo(() => [
        {
            title: firstStepTitle,
            Icon: SwapProgressBarFirstIcon,
            isPending: swapStatus === SwapStatusEnumKeys.DRAFT,
            hasFailed: !swapStatus,
        },
        {
            title: secondStepTitle,
            Icon: SwapProgressBarSecondIcon,
            hasFailed: swapStatus === SwapStatusEnumKeys.DEPOSIT_FAILED,
            isPending: swapStatus === SwapStatusEnumKeys.DEPOSIT_PENDING,
        },
        {
            title: thirdStepTitle,
            Icon: SwapProgressBarThirdIcon,
            hasFailed: swapStatus === SwapStatusEnumKeys.EXCHANGE_FAILED,
            isPending: swapStatus === SwapStatusEnumKeys.EXCHANGE_IN_PROGRESS ||
                swapStatus === SwapStatusEnumKeys.DEPOSIT_CONFIRMED,
        },
        {
            title: fourthStepTitle,
            Icon: SwapProgressBarFourthIcon,
            hasFailed: swapStatus === SwapStatusEnumKeys.WITHDRAW_FAILED,
            isPending: swapStatus === SwapStatusEnumKeys.WITHDRAW_IN_PROGRESS ||
                swapStatus === SwapStatusEnumKeys.EXCHANGE_COMPLETED,
        },
    ], [
        firstStepTitle,
        fourthStepTitle,
        secondStepTitle,
        swapStatus,
        thirdStepTitle,
    ]);
    const stepStatuses = useMemo(() => DEPOSIT_STEPS.map((_, index) => swapStatus === SwapStatusEnumKeys.WITHDRAW_COMPLETED ||
        DEPOSIT_STEPS.slice(index).some((item) => item.isPending || item.hasFailed)), [DEPOSIT_STEPS, swapStatus]);
    return (_jsxs(SwapProgressBarContainer, { className: className, children: [_jsx(ProgressLine, {}), DEPOSIT_STEPS.map((item, index) => {
                const hasPassed = stepStatuses[index];
                const iconColor = hasPassed || item.hasFailed
                    ? colors.text.interactive
                    : colors.borders.default;
                let icon;
                const { Icon: ItemIcon } = item;
                if (item.hasFailed) {
                    icon = _jsx(SwapFailedIcon, { color: iconColor });
                }
                else if (!item.isPending && hasPassed) {
                    icon = _jsx(SwapSuccessIcon, { color: iconColor });
                }
                else {
                    icon = (_jsx(ItemIcon, { color: item.isPending ? colors.text.default : iconColor }));
                }
                return (_jsxs(StepWrapper, { hasPassed: hasPassed, children: [_jsx(CircleImg, { hasPassed: hasPassed, isPending: item.isPending, hasFailed: item.hasFailed, children: icon }), _jsx(SwapStepTitle, { isPending: hasPassed, type: "caption", fontFamily: "primaryMedium", color: hasPassed ? colors.text.default : colors.text.secondary, children: item.title }), _jsx(Loader, { isPending: item.isPending })] }, index));
            })] }));
};
export default SwapProgressBar;
//# sourceMappingURL=SwapProgressBar.js.map